import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/project/creation/list.scss';
import { closest } from 'next/javascripts/modules/dom';

const TAB_INDEX_MAPPING = { 'template-center': 0, team: 1 };

Component('tr-project-creation-list', {
  mixins: [eventListenerMixin],

  properties: {
    activeTab: {
      type: String,
      default: 'template-center',
      observer() {
        this.tabChanged();
      },
    },
    selectedTemplateCategory: {
      type: String,
      default: 'develop',
      observer() {
        this.categoryChanged();
      },
    },
  },

  ready() {
    this.categorySelector = this.querySelector('.category-selector');
    this.selectorField = this.querySelector('.category-selector-field');
    this.container = this.querySelector('.template-container');
    this.tabs = this.querySelector('.tr-tabs');
    this.listenTo(this.querySelector('.tr-tabs'), 'tr-tabs:activated', this.tabClicked.bind(this));
    this.listenTo(this.categorySelector, 'click', this.handCategorySelectorClick.bind(this));
    this.listenTo(this.selectorField, 'tr-selector-field:change', this.handleSelectorChange.bind(this));
    this.initFromSessionStorage();
  },

  disconnected() {
    this.stopListening();
    this.destroyGuideTooltip();
  },

  initFromSessionStorage() {
    this.initTabs();
    this.initCategorySelector();
    this.tabChanged();
  },

  initTabs() {
    const activeTab = window.sessionStorage.getItem('activeTab');
    if (activeTab) {
      this.tabs.activeIndex = TAB_INDEX_MAPPING[activeTab];
      this.activeTab = activeTab;
    }
  },

  initCategorySelector() {
    const selected = window.sessionStorage.getItem('selectedTemplateCategory');
    if (selected) {
      this.selectorField.setValue(selected);
    }
  },

  tabClicked(event) {
    this.activeTab = event.detail.tab.dataset.name;
    window.sessionStorage.setItem('activeTab', event.detail.tab.dataset.name);
  },

  handCategorySelectorClick(event) {
    if (!closest(event.target, '.category-selector-field')) {
      this.selectorField.toggleList();
    }
    this.destroyGuideTooltip();
  },

  tabChanged() {
    if (this.activeTab === 'template-center') {
      this.selectedTemplateCategory = this.selectorField.getValue();
      this.showCategorySelector();
    } else {
      this.selectedTemplateCategory = this.activeTab;
      this.hideCategorySelector();
    }
  },

  handleSelectorChange() {
    this.selectedTemplateCategory = this.selectorField.getValue();
    window.sessionStorage.setItem('selectedTemplateCategory', this.selectedTemplateCategory);
  },

  categoryChanged() {
    this.setTemplate(this.selectedTemplateCategory);
  },

  setTemplate(template) {
    const currentTemplate = document.querySelector(`#${template}-templates`);
    const content = currentTemplate.content.cloneNode(true);
    $(this.container).empty();
    this.container.appendChild(content);
  },

  destroyGuideTooltip() {
    $('.simple-tooltip').addClass('hidden');
  },

  showCategorySelector() {
    this.categorySelector.classList.remove('hidden');
  },

  hideCategorySelector() {
    this.categorySelector.classList.add('hidden');
  },
});
